<template>
    <div class="number-cell" :class="field.alignment" @dblclick="enableEdit">
        <template v-if="editing">
            <a-input-number
                v-model="value"
                @blur="disableEdit"
                @keyup.enter="disableEdit"
                :formatter="formatter"
                :parser="parser"
                class="borderless-input"
            />
        </template>
        <template v-else>
            {{ formattedValue }}
        </template>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "NumberCell",
    props: {
        record: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            editing: false,
            value: this.record.data[this.field._id] || 0,
        };
    },
    computed: {
        formattedValue() {
            return this.formatter(this.value);
        },
        decimalFormat() {
            return this.field.options?.number?.decimalFormat || "0";
        },
    },
    methods: {
        enableEdit() {
            this.editing = true;
            this.$nextTick(() => {
                this.$refs.input?.focus();
            });
        },
        async disableEdit() {
            this.editing = false;
            try {
                const isChanged = this.record.data[this.field._id] !== this.value;
                if (isChanged) {
                    await this.$emit("update-record", {
                        recordId: this.record._id,
                        fieldId: this.field._id,
                        value: this.value,
                    });
                }
            } catch (error) {
                console.error(this.$t("tables.recordUpdatingError"), error);
                this.$message.error(this.$t("tables.recordUpdatingError"));
            }
        },
        formatter(value) {
            if (!value) return "";

            // Değerin sayı olduğundan emin olun
            const number = Number(value);
            if (isNaN(number)) return value; // Geçersiz sayı ise orijinal değeri döndür

            const parts = this.decimalFormat.split(".");
            const integerPart = parts[0].length;
            const decimalPart = parts[1]?.length || 0;

            return number.toFixed(decimalPart).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        },
        parser(value) {
            return value.replace(/\$\s?|(,*)/g, "");
        },
    },
});
</script>

<style scoped lang="scss">
.number-cell {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;

    &.left {
        justify-content: flex-start;
    }

    &.center {
        justify-content: center;
    }

    &.right {
        justify-content: flex-end;
    }

    .borderless-input {
        border: none;
        outline: none;
        background: transparent;
        width: 100%;
        text-align: inherit;
    }
}
</style>
